@if (showLogin) {
  <div class="posr">
    <div class="login-wrapper">
      <mat-form-field appearance="outline" class="d-block">
        <mat-label i18n>login</mat-label>
        <input type="text" matInput [(ngModel)]="login">
      </mat-form-field>

      <mat-form-field  appearance="outline" class="d-block">
        <mat-label i18n>password</mat-label>
        <input type="password"
               (keyup.enter)="auth()"
               matInput [(ngModel)]="password">
      </mat-form-field>

      <div class="d-flex w100">
        <div class="f-gr-1"></div>

        <!-- Компонент 2FA всегда присутствует -->
        <app-two-factor-setup></app-two-factor-setup>

        <!-- Кнопка входа скрывается при активации 2FA -->
        @if (!showActivation) {
          <button
            (click)="auth()"
            mat-raised-button color="primary"
            class="submit-button text-uppercase w50"
            [disabled]="!login || !password">
            Sign in
          </button>
        }
      </div>
    </div>
  </div>
}

<app-logo [fz]="50"></app-logo>

<div id="id1" (click)="openMy(1)"></div>
<div id="id2" (click)="openMy(7)"></div>
